import type { ReactNode } from "react";
import { Panel } from "@/components/ui/Panel";

/**
 * A document the module cannot show: why, and the file itself at its signed
 * URL. The URL is another origin, where a browser ignores `download`, so the
 * link opens a tab rather than replacing the page the attorney is on.
 */
export function OpenElsewhere({
  url,
  label,
  children,
}: {
  url: string;
  label: string;
  children: ReactNode;
}) {
  return (
    <Panel
      shape="row"
      pad="roomy"
      className="flex flex-col items-start gap-3 bg-muted/40 text-sm"
    >
      {children}
      <a
        href={url}
        target="_blank"
        rel="noreferrer"
        className="rounded-md border border-border bg-card px-3 py-1.5 text-[12.5px] font-semibold hover:bg-muted"
      >
        {label}
      </a>
    </Panel>
  );
}
